
import { useRef, useCallback } from 'react';

export const useEventThrottling = () => {
  const lastExecutionRef = useRef<{ [key: string]: number }>({});

  const throttledEventHandler = useCallback((
    eventName: string,
    handler: () => void,
    delay: number = 1000
  ) => {
    const now = Date.now();
    const lastExecution = lastExecutionRef.current[eventName] || 0;

    if (now - lastExecution >= delay) {
      lastExecutionRef.current[eventName] = now;
      handler();
    }
  }, []);

  return { throttledEventHandler };
};
